import { pipe } from 'ramda';
import { setEvent, setCategory, dispatchEvent } from '@creditas-lab/analytics-events';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type DispatchEvent = (eventData?: any) => void;

const dispatchFrontendDashboardEvent: DispatchEvent = pipe(
  setCategory('customer_dashboard'),
  setEvent('frontend_interaction_event'),
  dispatchEvent,
);

export { dispatchFrontendDashboardEvent };
